import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface PromptInput {
  name: string;
  type: 'text' | 'textarea';
  placeholder?: string;
  value?: string;
}

export interface DialogConfig {
  id: number;
  header: string;
  message?: string;
  details?: string;
  confirmText: string;
  cancelText?: string;
  inputs?: PromptInput[];
  resolve: (value: any) => void;
}

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private _open = new Subject<DialogConfig>();
  private _close = new Subject<number>();
  private nextId = 0;

  get open$(): Observable<DialogConfig> { return this._open.asObservable(); }
  get close$(): Observable<number> { return this._close.asObservable(); }

  confirm(options: { header: string; message?: string; confirmText?: string; cancelText?: string }): Promise<boolean> {
    return new Promise(resolve => {
      this._open.next({
        id: this.nextId++,
        header: options.header,
        message: options.message,
        confirmText: options.confirmText ?? 'Confirm',
        cancelText: options.cancelText ?? 'Cancel',
        resolve,
      });
    });
  }

  alert(options: { header: string; message?: string; details?: string; okText?: string }): Promise<void> {
    return new Promise(resolve => {
      this._open.next({
        id: this.nextId++,
        header: options.header,
        message: options.message,
        details: options.details,
        confirmText: options.okText ?? 'OK',
        resolve,
      });
    });
  }

  prompt(options: { header: string; message?: string; inputs: PromptInput[]; confirmText?: string; cancelText?: string }): Promise<Record<string, string> | null> {
    return new Promise(resolve => {
      this._open.next({
        id: this.nextId++,
        header: options.header,
        message: options.message,
        inputs: options.inputs,
        confirmText: options.confirmText ?? 'Confirm',
        cancelText: options.cancelText ?? 'Cancel',
        resolve,
      });
    });
  }

  close(id: number) {
    this._close.next(id);
  }
}
